export const anesthesiologyAndResuscitationConst = {
  path: "/single-programs/anesthesiology-and-resuscitation",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – АНЕСТЕЗИОЛОГИЯ И РЕАНИМАТОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Анестезиология и реаниматология — профессия, где спасают жизни каждый день</h2>
      <p>
        Анестезиология и реаниматология — это ключевое направление медицины, обеспечивающее безопасность пациентов во время операций и в
        критических состояниях. Анестезиологи-реаниматологи — незаменимые специалисты в операционных, отделениях интенсивной терапии,
        реанимациях и экстренной медицине. Они отвечают за обезболивание, вентиляцию легких, восстановление функций сердца, почек, мозга и
        других органов.
      </p>
      <p>Это профессия высокой ответственности, но и высокого признания. Именно эти врачи стоят на страже жизни в самые сложные моменты.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Общая и регионарная анестезия</li>
        <li>Интенсивная терапия и реанимация</li>
        <li>Медикаментозное сопровождение операций</li>
        <li>Сердечно-лёгочная реанимация (advanced protocols)</li>
        <li>Ведение пациентов в критических и пограничных состояниях</li>
        <li>Аппаратная поддержка дыхания и гемодинамики</li>
        <li>Внутрибольничная инфекция и антисептика</li>
        <li>Этические вопросы и стрессоустойчивость врача</li>
      </ul>
      <p>
        Учебный процесс построен на интеграции теории с симуляциями, клинической практикой в стационарах и обучении на современных
        анестезиологических системах.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Анестезиолог-реаниматолог в многопрофильной больнице</li>
        <li>Врач отделения интенсивной терапии</li>
        <li>Специалист по экстренной медицине и шоковым состояниям</li>
        <li>Транспортный врач скорой помощи и санитарной авиации</li>
        <li>Медицинский консультант по анестезии в хирургии, родах, трансплантологии</li>
      </ul>
      <h2>Средний доход специалистов в Европе:</h2>
      <p>
        от <strong>€70,000 до €130,000 в год,</strong> в зависимости от страны, стажа и специализации
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Современные симуляционные центры и оборудование</li>
        <li>Возможность учиться очно или дистанционно (с клиническими модулями в ЕС)</li>
        <li>Интенсивная подготовка под руководством опытных врачей</li>
        <li>Практика в университетских клиниках</li>
        <li>Обучение на русском или английском языке</li>
        <li>Поддержка при трудоустройстве в странах Европы</li>
      </ul>
      <p>
        <strong>
          Анестезиология — это искусство контроля боли и жизни. Это вызов, ответственность и уверенность в своих силах. Если вы хотите быть
          тем, кто делает невозможное возможным — вам сюда.
        </strong>
      </p>
      <h2>Как поступить?</h2>
      <p>
        Поступить на программу легко — приёмная комиссия поможет с оформлением всех документов. Мы сопровождаем вас от заявки до первого дня
        учёбы.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Анестезиология и реаниматология — профессия, где спасают жизни каждый день
    Анестезиология и реаниматология — это ключевое направление медицины, обеспечивающее безопасность пациентов во время операций и в критических состояниях. Анестезиологи-реаниматологи — незаменимые специалисты в операционных, отделениях интенсивной терапии, реанимациях и экстренной медицине. Они отвечают за обезболивание, вентиляцию легких, восстановление функций сердца, почек, мозга и других органов.
    Это профессия высокой ответственности, но и высокого признания. Именно эти врачи стоят на страже жизни в самые сложные моменты.

    Что вы будете изучать?
    • Общая и регионарная анестезия
    • Интенсивная терапия и реанимация
    • Медикаментозное сопровождение операций
    • Сердечно-лёгочная реанимация (advanced protocols)
    • Ведение пациентов в критических и пограничных состояниях
    • Аппаратная поддержка дыхания и гемодинамики
    • Внутрибольничная инфекция и антисептика
    • Этические вопросы и стрессоустойчивость врача
    Учебный процесс построен на интеграции теории с симуляциями, клинической практикой в стационарах и обучении на современных анестезиологических системах.

    Кем можно работать после окончания?
    • Анестезиолог-реаниматолог в многопрофильной больнице
    • Врач отделения интенсивной терапии
    • Специалист по экстренной медицине и шоковым состояниям
    • Транспортный врач скорой помощи и санитарной авиации
    • Медицинский консультант по анестезии в хирургии, родах, трансплантологии

    Средний доход в Европе:
    от €70,000 до €130,000 в год, в зависимости от страны, стажа и специализации

    Почему выбирают нас?
    • Современные симуляционные центры и оборудование
    • Возможность учиться очно или дистанционно (с клиническими модулями в ЕС)
    • Интенсивная подготовка под руководством опытных врачей
    • Практика в университетских клиниках
    • Обучение на русском или английском языке
    • Поддержка при трудоустройстве в странах Европы

    Анестезиология — это искусство контроля боли и жизни. Это вызов, ответственность и уверенность в своих силах. Если вы хотите быть тем, кто делает невозможное возможным — вам сюда.

    Как поступить?
    Поступить на программу легко — приёмная комиссия поможет с оформлением всех документов. Мы сопровождаем вас от заявки до первого дня учёбы.
  `,
};
